export function initTabTitleNotifier() {
    const originalTitle = document.title;
    const phrases = [
        "¡Vuelve! No te vayas",
        "No pierdas la oportunidad de encontrar tu modelo ideal.",
        "Estaremos aquí con ayuda personalizada",
        "¿Te perdiste? Vuelve con nosotros",
    ];
    let intervalId;

    document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
            intervalId = setInterval(function() {
                const randomIndex = Math.floor(Math.random() * phrases.length);
                document.title = phrases[randomIndex];
            }, 3000);
        } else {
            clearInterval(intervalId);
            document.title = originalTitle;
        }
    });
}
